import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import {
  CreateStickerConsumptionParams,
  ListStickerConsumptionRequestParams,
  StickerConsumption,
  UpdateStickerConsumptionParams
} from '~core/models/sticker-consumption.model';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class StickerConsumptionService {
  private _apiConstantsService = inject(ApiConstantsService);
  readonly apiUrl = this._apiConstantsService.stickerConsumptionsUrl;
  private _httpClient = inject(HttpClient);

  list(
    params?: ListStickerConsumptionRequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<StickerConsumption>> {
    return this._httpClient.get<Pagination<StickerConsumption>>(this.apiUrl, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  read(id: string): Observable<StickerConsumption> {
    return this._httpClient.get<StickerConsumption>(`${this.apiUrl}/${id}`);
  }

  create(data: CreateStickerConsumptionParams): Observable<StickerConsumption> {
    return this._httpClient.post<StickerConsumption>(this.apiUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    data: Partial<UpdateStickerConsumptionParams>
  ): Observable<StickerConsumption> {
    return this._httpClient.patch<StickerConsumption>(`${this.apiUrl}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  delete(id: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(`${this.apiUrl}/${id}`);
  }
}
